module.exports = __webpack_public_path__ + "static/parcours-jbdf-c0e92cff39548a960e6653943360630a.png";